import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
} from "@material-ui/core";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";

function ToolGroupButton({
  options,
  onClick,
  selectedTool,
  disabled,
  className = "",
  unitInfo,
  onClickSelect = false,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selected, setSelected] = useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    if (open && onClickSelect) {
      setSelectedIndex(0);
      onClick(options[0]);
    }
  }, [open]);

  const handleMenuItemClick = (event, index, option) => {
    setSelectedIndex(index);
    setOpen(false);
    onClick(option);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    const find = options.find((item) => item.key === selectedTool.key);
    if (find) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [selectedTool, options]);

  return (
    <>
      <ButtonGroup
        ref={anchorRef}
        aria-label="split button"
        className={`w-100 ${className}`}
        disabled={disabled}
      >
        <Tooltip title={t(options[selectedIndex].title)}>
          <IconButton
            className={`designButton ${selected && "active"} `}
            onClick={handleToggle}
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
          >
            <span className="submenu-sign" />
            <ReactSVG src={options[selectedIndex].icon} />
          </IconButton>
        </Tooltip>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 100 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="split-button-menu"
                  className={
                    unitInfo && unitInfo["Sys_tak_joft"] !== 0
                      ? "toolsPopperRail"
                      : "toolsPopper"
                  }
                >
                  {options.map((option, index) => (
                    <Tooltip
                      title={t(option.title)}
                      key={`${option.title}-${index}`}
                    >
                      <MenuItem
                        disabled={
                          option.disabled &&
                          (option.key === "FIX_SASH"
                            ? unitInfo["Sys_tak_joft"] !== 0
                            : unitInfo[option.disabled] === 0)
                        }
                        key={option}
                        selected={index === selectedIndex}
                        onClick={(event) =>
                          handleMenuItemClick(event, index, option)
                        }
                      >
                        <ReactSVG src={option.icon} />
                      </MenuItem>
                    </Tooltip>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default ToolGroupButton;
